import React from "react";
import "./index.scss";
import classnames from "classnames";

const cls = "AdaptionSection";

export interface IAdaptionSectionProps {
  className?: string;
}

/**
 * 自适应的断点
 */
export const AdaptionSection: React.SFC<IAdaptionSectionProps> = props => {
  const { className, children } = props;
  return <div className={classnames(cls, className)}>{children}</div>;
};
